import { defineNuxtRouteMiddleware, navigateTo } from '#imports';

export default defineNuxtRouteMiddleware(({ store, route }) => {
  const userRoles = store.state.auth.user.roles;

  if (!Object.entries(userRoles).some((role) => role.includes('media'))) {
    return navigateTo(route.fullPath);
  }
});
